import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 8,
	height: 8,
	viewBox: "0 0 8 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.0712554 0.964844L2.99301 6.80747C3.23872 7.29882 3.93992 7.29877 4.18558 6.80739L7.10645 0.964773C7.32805 0.521508 7.00571 0 6.51014 0H0.667522C0.171917 0 -0.150413 0.521574 0.0712554 0.964844Z",
		fill: "#525252"
	})
});
export default SvgArrowDown;
